import Header from './Header';
import Footer from './Footer';

/**
 * MainLayout - Wraps authenticated pages with header and footer
 *
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Page content to render between header and footer
 * @param {string} props.className - Optional additional CSS classes for main-body
 */
function MainLayout({ children, className = '' }) {
  console.log('[MainLayout] Rendering with className:', className);
  return (
    <div id="main-container">
      <Header />
      <div id="main-body" className={`content-container container-fluid ${className}`}>
        {children}
      </div>
      <Footer />
    </div>
  );
}

export default MainLayout;
